import type { SVGProps } from "react";

export function Minus(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="12"
      height="2"
      viewBox="0 0 12 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.600098 0.999951C0.600098 0.627159 0.902305 0.324951 1.2751 0.324951L10.7251 0.324952C11.0979 0.324952 11.4001 0.62716 11.4001 0.999951C11.4001 1.37274 11.0979 1.67495 10.7251 1.67495L1.2751 1.67495C0.902305 1.67495 0.600098 1.37274 0.600098 0.999951Z"
        fill="#1F1F1F"
      />
    </svg>
  );
}
